import { A11yModule } from '@angular/cdk/a11y';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatMenuModule } from '@angular/material/menu';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ArrowNavigationModule } from '@y42/core/arrow-navigation';
import { IconModule } from './../../../icon/src/lib/icon/icon.module';
import { FilterableItemsListComponent, IdentifyPipe } from './filterable-items-list.component';
import { FilterableListItemDirective } from './filterable-list-item.directive';
import { FilterableListSummaryItemDirective } from './filterable-list-summary-item.directive';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    MatCheckboxModule,
    MatChipsModule,
    MatIconModule,
    ScrollingModule,
    MatMenuModule,
    A11yModule,
    ArrowNavigationModule,
    IconModule,
  ],
  declarations: [
    FilterableItemsListComponent,
    FilterableListItemDirective,
    FilterableListSummaryItemDirective,
    IdentifyPipe,
  ],
  exports: [FilterableItemsListComponent, FilterableListItemDirective, FilterableListSummaryItemDirective],
})
export class FilterableItemsListModule {}
